// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  align-items: center;
}

.notify-button .mat-icon {
  display: block;
  margin: auto;
  font-size: 28px;
  width: 28px;
  height: 28px;
  line-height: 28px;
}
.notify-button .notify-badge {
  border-radius: 8px;
  background: #FFA726;
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  padding: 0 4px;
  min-width: 22px;
  height: 16px;
  line-height: 16px;
  position: absolute;
  top: 0;
  right: -5px;
}

::ng-deep .notify-menu {
  position: relative;
  max-width: 320px;
  width: 320px;
  min-height: 160px !important;
}
::ng-deep .notify-menu .mat-menu-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: calc(100vh - 60px);
  overflow: hidden;
  padding: 0;
}
::ng-deep .notify-menu .mat-menu-item {
  display: flex;
  height: auto !important;
  line-height: normal !important;
  padding-right: 16px !important;
  align-items: flex-start;
}
::ng-deep .notify-menu .mat-menu-item .mat-icon {
  flex-shrink: 0;
  margin-top: 8px;
  margin-right: 0;
}

.notify-title {
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  height: 48px;
  line-height: 48px;
  padding: 0 5px 0 14px;
}

.notify-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 0 40px;
}

.notify-container {
  flex: 1;
  overflow-y: auto;
}

.notify-message {
  flex: 1;
  line-height: normal;
  overflow: hidden;
  padding: 8px 0;
  white-space: normal;
  word-break: break-word;
}

.created {
  font-size: 12px;
  margin-top: 5px;
}

.primary {
  color: #2ab4c0;
}

.disabled {
  color: #999;
}

::ng-deep .notify-header {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::ng-deep .notify-body {
  font-size: 13px;
  white-space: normal;
  word-break: break-word;
}

::ng-deep .notify-corporate {
  color: #999;
  font-size: 13px;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.loading-wrapper {
  flex: 1;
  position: relative;
}

::ng-deep .noti-green, .noti-green {
  color: #4caf50;
}

::ng-deep .noti-warn, .noti-warn {
  color: #f90;
}

::ng-deep .noti-error, .noti-error {
  color: #d32f2f;
}

.default {
  cursor: default;
}

.pointer {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/notification/notification.component.scss"],"names":[],"mappings":"AAAA;EACG,aAAA;EACA,mBAAA;AACH;;AAGG;EACG,cAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAAN;AAGG;EACG,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AADN;;AAKA;EACG,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,4BAAA;AAFH;AAIG;EACG,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,UAAA;AAFN;AAKG;EACG,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,8BAAA;EACA,uBAAA;AAHN;AAKM;EACG,cAAA;EACA,eAAA;EACA,eAAA;AAHT;;AASA;EACG,eAAA;EACA,aAAA;EACA,8BAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;AANH;;AASA;EACG,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AANH;;AASA;EACG,OAAA;EACA,gBAAA;AANH;;AASA;EACG,OAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AANH;;AASA;EACG,eAAA;EACA,eAAA;AANH;;AASA;EACG,cAAA;AANH;;AASA;EACG,WAAA;AANH;;AASA;EACG,gBAAA;EACA,uBAAA;EACA,mBAAA;AANH;;AASA;EACG,eAAA;EACA,mBAAA;EACA,sBAAA;AANH;;AASA;EACG,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AANH;;AASA;EACG,OAAA;EACA,kBAAA;AANH;;AASA;EACG,cAAA;AANH;;AASA;EACG,WAAA;AANH;;AASA;EACG,cAAA;AANH;;AASA;EACG,eAAA;AANH;;AASA;EACG,eAAA;AANH","sourcesContent":[":host {\n   display: flex;\n   align-items: center;\n}\n\n.notify-button {\n   .mat-icon {\n      display: block;\n      margin: auto;\n      font-size: 28px;\n      width: 28px;\n      height: 28px;\n      line-height: 28px;\n   }\n\n   .notify-badge {\n      border-radius: 8px;\n      background: #FFA726;\n      display: inline-block;\n      font-size: 11px;\n      font-weight: 600;\n      padding: 0 4px;\n      min-width: 22px;\n      height: 16px;\n      line-height: 16px;\n      position: absolute;\n      top: 0;\n      right: -5px;\n   }\n}\n\n::ng-deep .notify-menu {\n   position: relative;\n   max-width: 320px;\n   width: 320px;\n   min-height: 160px !important;\n\n   .mat-menu-content {\n      display: flex;\n      flex-direction: column;\n      height: 100%;\n      max-height: calc(100vh - 60px);\n      overflow: hidden;\n      padding: 0;\n   }\n\n   .mat-menu-item {\n      display: flex;\n      height: auto !important;\n      line-height: normal !important;\n      padding-right: 16px !important;\n      align-items: flex-start;\n\n      .mat-icon {\n         flex-shrink: 0;\n         margin-top: 8px;\n         margin-right: 0;\n      }\n  }\n}\n\n\n.notify-title {\n   font-size: 18px;\n   display: flex;\n   justify-content: space-between;\n   flex-shrink: 0;\n   height: 48px;\n   line-height: 48px;\n   padding: 0 5px 0 14px;\n}\n\n.notify-empty {\n   display: flex;\n   flex-direction: column;\n   align-items: center;\n   justify-content: center;\n   padding: 24px 0 40px;\n}\n\n.notify-container {\n   flex: 1;\n   overflow-y: auto;\n}\n\n.notify-message {\n   flex: 1;\n   line-height: normal;\n   overflow: hidden;\n   padding: 8px 0;\n   white-space: normal;\n   word-break: break-word;\n}\n\n.created {\n   font-size: 12px;\n   margin-top: 5px;\n}\n\n.primary {\n   color: #2ab4c0;\n}\n\n.disabled {\n   color: #999;\n}\n\n::ng-deep .notify-header {\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n}\n\n::ng-deep .notify-body {\n   font-size: 13px;\n   white-space: normal;\n   word-break: break-word;\n}\n\n::ng-deep .notify-corporate {\n   color: #999;\n   font-size: 13px;\n   margin-top: 2px;\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n}\n\n.loading-wrapper {\n   flex: 1;\n   position: relative;\n}\n\n::ng-deep .noti-green, .noti-green {\n   color: #4caf50;\n}\n\n::ng-deep .noti-warn, .noti-warn {\n   color: #f90;\n}\n\n::ng-deep .noti-error, .noti-error {\n   color: #d32f2f;\n}\n\n.default {\n   cursor: default;\n}\n\n.pointer {\n   cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
